/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import Value from 'components/value';
import { formatDateTime } from 'common/helpers/format';

import AppTable from 'components/appTable';
import SearchBox from 'components/form/searchBox';
import Gap from 'components/gap';
import PanelBoxLayout from 'components/layout/panelBox';
import { useActions } from 'common/hooks/useActions';
import PrimaryButton from 'components/form/buttons/primaryButton';
import TicketFilterPopup from '../filterForm';

import * as S from './styles';
import * as T from 'common/types';

interface IProps {
  data: [];
  departments: [];
  ticketCategory: [];
  loading: boolean;
}

export default function TicketTable({ data, departments, ticketCategory, loading }: IProps) {
  const { ticketsRequestAction } = useActions();
  const [meta, setMeta] = useState({
    page: 1,
    page_size: 1000,
    search: '',
    type: ''
  });

  const fetchData = () => {
    ticketsRequestAction(meta);
  };

  useEffect(() => {
    fetchData();
  }, [meta]);

  // const handleChangePage = (page: number) => {
  //   setMeta({ ...meta, page });
  // };

  // const handleChangePageSize = (page_size: number) => {
  //   setMeta({ ...meta, page_size });
  // };

  return (
    <S.Content>
      <PanelBoxLayout>
        <S.Head>
          <SearchBox onChange={(e) => setMeta({ ...meta, search: e })} placeholder="Search" />
          <TicketFilterPopup
            setFilter={setMeta}
            filter={meta}
            departments={departments}
            ticketCategory={ticketCategory}
          />
        </S.Head>
        <Gap size="20px" />
        <AppTable
          headers={[
            { id: 1, key: 'id', title: 'Employee ID', dir: 'left', width: 110 },
            { id: 2, key: 'icon', title: 'Name', dir: 'left', width: 64 },
            { id: 3, key: 'category', title: 'Department', dir: 'left', width: 110 },
            { id: 4, key: 'title', title: 'Job Title', dir: 'left' },
            { id: 5, key: 'requestLocation', title: 'Area', dir: 'left', width: 100 },
            { id: 6, key: 'createdAt', title: 'Date', dir: 'left', width: 156 },
            { id: 7, key: 'entry', title: 'Entry', width: 70 },
            { id: 8, key: 'exit', title: 'Exit', width: 70 },
            { id: 9, key: 'edit', title: '', type: 'actions', width: 125 }
          ]}
          data={data}
          loading={loading}
          altanfeethiFields={{
            id: (item: T.Pages.TicketItem) => <S.Div className="text-left">{item?.id}</S.Div>,
            icon: (item: T.Pages.TicketItem) => (
              <S.Div className="">
                <S.Icon>
                  <S.Image src={item.category?.icon} />
                </S.Icon>
              </S.Div>
            ),
            category: (item: T.Pages.TicketItem) => <S.Div className="text-left">{item.category?.title}</S.Div>,
            title: (item: T.Pages.TicketItem) => <S.Div className="text-left captal">{item.title}</S.Div>,
            requestLocation: (item: T.Pages.TicketItem) => (
              <S.Div className="text-left captal">{item.requestLocation}</S.Div>
            ),
            createdAt: (item: T.Pages.TicketItem) => (
              <S.Div className="text-left captal">
                <Value mono>{formatDateTime(item.createdAt)}</Value>
              </S.Div>
            ),
            entry: () => (
              <S.Div className="flex-center" style={{ flexDirection: 'column', gap: 3 }}>
                <S.Span>10:22</S.Span>
                <S.Floor className="flex-center">Floor 1</S.Floor>
              </S.Div>
            ),
            exit: () => (
              <S.Div className="flex-center" style={{ flexDirection: 'column', gap: 3 }}>
                <S.Span>10:22</S.Span>
                <S.Floor className="flex-center">Floor 1</S.Floor>
              </S.Div>
            ),
            edit: (item: T.Pages.TicketItem) => (
              <PrimaryButton
                link={`/panel/access/activities/${item.id}`}
                className="secondary sm"
                style={{ margin: 'auto' }}
              >
                Activities
              </PrimaryButton>
            )
          }}
        />
      </PanelBoxLayout>
      {/* {data.totalPages ? (
        <PaginationApp
          page={meta.page}
          count={meta.page_size * data.totalPages}
          handleChangePage={(page: number) => handleChangePage(page)}
          key={data.totalPages}
          pageSize={meta.page_size}
          handleChangeTake={handleChangePageSize}
        />
      ) : (
        <></>
      )} */}
    </S.Content>
  );
}
